import { Stack, type StackProps, styled } from '@mui/material'
import { ComponentType } from 'react'

type RecurrenceCalendarWrapperProps = StackProps

export const RecurrenceCalendarWrapper = styled(Stack, {
  name: 'RecurrenceCalenderWrapper',
})<RecurrenceCalendarWrapperProps>(({ theme: { spacing } }) => ({
  width: '100%',
  gap: spacing(1),
})) as ComponentType<RecurrenceCalendarWrapperProps>
